<template>
  <div id="app1">
    <div id="chinaMap1" style="height: 600px; width: 800px" ref="myEchart1"></div>
    <!-- <div id="myChart" style="width: 100%;height:400px;"></div> -->
  </div>
</template>

<script>
import echarts from "echarts/lib/echarts"
require("echarts/map/js/china"); // 引入中国地图数据
import city from "echarts/map/json/china-cities.json";
export default {
  name: "App1",
  data(){
    return {

    }
  },
  mounted() {
    this.chinaConfigure(this.cityAllList);
  },
  props:{
    cityAllList: {
       type: Array,
       default: []
    }
  },
  watch:{
    cityAllList(){
       this.chinaConfigure(this.cityAllList);
     }
  },
  methods: {
    chinaConfigure(list) {
      let x = []
      list.forEach(lists => {
         if(lists.eventName.indexOf("市")> -1){
           lists.eventName=lists.eventName.substr(0,lists.eventName.length-1)
         }
      })
      echarts.registerMap('city', city);
      let myChart1 = echarts.init(document.getElementById("chinaMap1"));





      let arrs = [];
      list.forEach(item => {
          arrs.push({
            name: item.eventName,
            value: parseInt(item.eventValue)
          })
      });

      var option1 = {
        backgroundColor: "#FFFFFF", //设置背景颜色
        title: {
          show: true,
          text: "市级分布",
          subtext: "",
          left: "left",
        },
        tooltip: {
          trigger: "item",
        },
        //左侧小导航图标
        visualMap: {
          show: true,
          x: "left",
          y: "bottom",
          splitList: [
            { start: 20, end: 50 },
            { start: 1, end: 19 },
            { start: 0, end: 0 },
          ],
          color: ["#1E90FF", "#77B4F1", "#DDF8FF"],
        },
        //配置属性
        series: [
          {
            name: "访问人数",
            type: "map",

            map: "city",
            roam: true,
            zoom: 3.0,
            label: {
                normal: {
                    show: true,
                },
                emphasis: {
                    show: false
                }
            },
            data: arrs,
          },
        ],
      };

      console.log(option1)
      /**
       *  使用刚指定的配置项和数据显示图表。
       *  */
      myChart1.setOption(option1);
    }
  },
  created() {

  }
};
</script>
